import {Entity} from "../helpers/Entity"
import PricingRow, {PricingRowDto} from "../pricing/PricingRow"

export type LimitRuleDto = {
    readonly usedCapacity: number
    readonly isMaxCapacitySet: boolean
    readonly maxCapacity: number
    readonly rowCounts: object
    readonly rowLimits: object
}

export type ValidationRulesDto = {
    key: string
    config: object | LimitRuleDto
}

export type PriceListAttributes = {
    validationRules: ValidationRulesDto
    expirationDate: string
    notificationDisabled:boolean,
    currency: string
    items: PricingRowDto[]
    customerType: string
    docGeneratedStatus: string
    creditMemoContactReceiverId: string
    customerTags: string[]
    identifier: string
    objectType: string,
}

export type PriceListDto = {
    id: string
    type: string
    attributes: PriceListAttributes
}

export type DuplicatePriceListDto = {
    objectType: string,
    title: string,
    creditMemoContactReceiverId: string
}

export default class PriceList implements Entity {
    private dto: PriceListDto
    private rows: PricingRow[]

    constructor(dto: PriceListDto) {
        this.dto = dto
        this.rows = dto.attributes.items.map(i => new PricingRow(i))
    }

    isLoaded() {
        return this.dto.id != "" && this.dto.type == "price-lists"
    }

    getId() {
        return this.dto.id
    }

    getValidationConfig() {
        return this.dto.attributes.validationRules.config
    }

    getValidationStrategyKey() {
        return this.dto.attributes.validationRules.key
    }

    getExpirationDate() {
        return this.dto.attributes.expirationDate
    }

    getRows() {
        return this.rows
    }

    getDocGeneratedStatus() {
        return this.dto.attributes.docGeneratedStatus
    }


    getCustomerType() {
        return this.dto.attributes.customerType
    }

    getCustomerTags() {
        return this.dto.attributes.customerTags ?? []
    }

    getCurrency() {
        return this.dto.attributes.currency
    }

    getItems() {
        return this.dto.attributes.items
    }

    getObjectType() {
        return this.dto.attributes.objectType
    }

    getNotificationDisabled() {
        return this.dto.attributes.notificationDisabled
    }

    getDto() {
        return this.dto
    }

}



// WEBPACK FOOTER //
// ./src/state/price-list/PriceList.ts